module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: [_vm.prefixMenuClass + '__item-group']
  }, [_c('span', {
    class: [_vm.prefixMenuClass + '__item-group-title']
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('ul', [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4123d5bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/menu-group.vue
// module id = 365
// module chunks = 0